// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import TextContentTranslationModel from '../../model/text-content-translation-model';
import TextContentTranslationDTO from '../dto/text-content-translation-dto';
import dtoSchema from '../schemas/text-content-translation-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class TextContentTranslationModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<TextContentTranslationDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.textContentKey = data.textContentKey ?? undefined;
      this.scope = data.scope ?? undefined;
      this.language = data.language ?? undefined;
      this.content = data.content ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  textContentKey?: string;
  /**
  */
  scope?: string;
  /**
  */
  language?: string;
  /**
  */
  content?: string;

  static toModel(dto: DeepPartial<TextContentTranslationDTO>): TextContentTranslationModel;
  static toModel(dto: DeepPartial<TextContentTranslationDTO> | undefined | null): TextContentTranslationModel | undefined;
  static toModel(dto: DeepPartial<TextContentTranslationDTO> | undefined | null): TextContentTranslationModel | undefined {
    return dto ? new TextContentTranslationModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<TextContentTranslationModel> | TextContentTranslationModel): TextContentTranslationDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      textContentKey: unwrapped.textContentKey,
      scope: unwrapped.scope,
      language: unwrapped.language,
      content: unwrapped.content,
    } as TextContentTranslationDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for TextContentTranslationModel, can not map to TextContentTranslationDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
